import { Box, styled } from '@mui/material';

/** 레거시 마크업 class 보충 — V2 저장 HTML 도 같은 class 를 씀 */
export const InfluencerMonthlyReportRoot = styled(Box)`
  & .form-group + .form-group {
    margin-top: 16px;
  }
  & .label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 600;
  }
  /* 공통 표의 break-all 보다 우선해야 영문 머리글이 단어 중간에서 안 끊김 */
  & .approval-form-table th {
    word-break: keep-all;
  }
  & .approval-form-table .text-center {
    text-align: center;
  }
  & .approval-form-table .text-left {
    text-align: left;
  }
  & .approval-form-table .text-right {
    text-align: right;
  }
`;
